<template>
  <header :class="['header-nav-desktop', { 'is-sticky': isSticky }]">
    <div class="navbar-container">
      <!-- 左侧LOGO+品牌名 -->
      <div class="navbar-logo" @click="$router.push('/')">
        <img src="@/assets/images/logo.png" alt="logo" class="logo-img" />
        <span class="brand-name">{{ $t('nav.brand') }}</span>
      </div>

      <!-- 中间主菜单 -->
      <nav class="navbar-menu">
        <ul>
          <li v-for="item in navList" :key="item.path">
            <router-link :to="item.path" active-class="active-link" exact>{{ item.label }}</router-link>
          </li>
        </ul>
        <!-- 右侧Contact+语言切换 -->
        <div class="navbar-actions">
          <button class="contact-btn" type="default" size="medium" @click="handleContact">{{ $t('nav.contact')
          }}</button>
          <span class="lang-btn" @click="toggleLanguage">
            <span class="flag-circle-outer">
              <img
                :src="currentLanguage === 'zh' ? require('@/assets/images/chinese.png') : require('@/assets/images/english.png')"
                :alt="currentLanguage === 'zh' ? 'English' : '中文'" class="flag-img" />
            </span>
          </span>
        </div>
      </nav>


    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNavDesktop',
  data() {
    return {
      isSticky: false
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    },
    navList() {
      return [
        { label: this.$t('nav.home'), path: '/' },
        { label: this.$t('nav.services'), path: '/services' },
        { label: this.$t('nav.story'), path: '/about' },
        { label: this.$t('nav.testimonials'), path: '/testimonials' },
        { label: this.$t('nav.parents'), path: '/parents' },
        { label: this.$t('nav.blog'), path: '/blog' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleContact() {
      if (this.$route.path !== '/practice') {
        this.$router.push('/practice')
      }
    },
    toggleLanguage() {
      const newLang = this.currentLanguage === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang
      localStorage.setItem('language', newLang)
    },
    handleScroll() {
      this.isSticky = window.scrollY > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.header-nav-desktop {
  width: 100%;
  background: #fff;
}

.header-nav-desktop.is-sticky {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-shadow: 0 2px 8px rgba(40, 41, 56, 0.08);
  animation: stickyFadeIn 0.3s;
}

@keyframes stickyFadeIn {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.navbar-container {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 80px;
}

.navbar-logo {
  display: flex;
  align-items: center;
  cursor: pointer;

  .logo-img {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    margin-right: 6px;
    object-fit: contain;
    background: #fff;
  }

  .brand-name {
    font-size: 24px;
    font-weight: 700;
    color: #282938;
  }
}

.navbar-menu {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-right: 30px;

  ul {
    display: flex;
    flex-direction: row;
    gap: 32px;
    list-style: none;
    margin: 0;
    padding: 0;
    width: fit-content;
    max-width: 625px;
    height: 40px;
    align-items: center;
    margin-right: 30px;

    li {
      display: flex;
      align-items: center;
      height: 40px;
      color: #282938;

      a {
        color: #282938;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        padding: 8px 0;
        position: relative;
        transition: color 0.2s;
        opacity: 0.5;

        &.active-link {
          color: #282938;
          font-weight: 500;
          opacity: 1;
        }

        &:hover {
          color: #282938;
          opacity: 1;
        }
      }
    }
  }
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 18px;

  .contact-btn {
    border: 1.5px solid #282938;
    border-radius: 22px;
    background: #fff;
    color: #282938;
    font-weight: 500;
    padding: 0 22px;
    height: 38px;
    transition: all 0.2s;
    font-size: 16px;

    &:hover {
      background: #282938;
      color: #fff;
    }
  }

  .lang-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 22px;

    .flag-circle-outer {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      position: relative;
    }

    .flag-img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}
</style>